import './bootstrap';
import router from './routes';

// Vue.component('vorsi-toolbar', require('./components/Toolbar.vue').default);
Vue.component('vorsi-footer', require('./components/Footer.vue').default);
// Vue.component('vorsi-headline', require('./homepage/components/Headline.vue').default);
// Vue.component('vorsi-overview', require('./homepage/components/Overview.vue').default);
// Vue.component('vorsi-services', require('./homepage/components/Services.vue').default);
// Vue.component('vorsi-features', require('./homepage/components/Features.vue').default);

// Vue.component('vorsi-signup-form', require('./tryForFree/components/signUpForm.vue').default);

new Vue({
    el: '#app',
    router,
});
